<div class="embed-container" provide-parent-form>
	<embed-preview class="contents"
		[mediaclip]="mediaclip"
		[configuration]="{standAlone: true, autoPlay: false, alwaysShow: false, showVideo: false}"
		[isActive]="isActive"
		[form]="form"
		name="embed-preview"
		(onPlayoutChange)="onPlayoutChanged($event)">
		<div class="custom-warning">
			<span *ngIf="mediaclip?.status === 'draft'" class="message warning ng-binding">
				<i class="fa" ></i>&nbsp;{{ 'HELP.MEDIACLIP_NOT_PUBLISHED' | translate }}.&nbsp;<button class="button publish-button" (click)="publish();" [hidden]="embed">PUBLISH</button>
			</span>
		</div>
		
		<div class="embargo">
			<bb-embargo name="embargoDates" [(ngModel)]="embargo" (ngModelChange)="onEmbargoChange($event)"></bb-embargo>
		</div>
	</embed-preview>
</div>
